import { jsx as _jsx } from "react/jsx-runtime";
import gif from "@assets/gifs/notfound.gif";
/**
 * NotFound component displays a "page not found" message, typically with an illustrative GIF.
 * It provides a visual cue to the user that the requested resource was not found.
 *
 * @component
 * @author niyas.shajahan
 * @since 2025-06-19
 */
var NotFound = function () {
    return (_jsx("div", { className: "flex flex-col items-center justify-center min-h-[calc(100vh-3rem)]", children: _jsx("img", { className: "w-full max-w-screen-md h-auto animate-zoom-in duration-500 z-0 dark:bg-transparent mix-blend-multiply ", src: gif, alt: "Not Found" // Changed alt text for clarity
         }) }));
};
export default NotFound;
